export const SAVE_ICON = {
  width: 24,
  height: 24,
  svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/><path d="M7 3v4a1 1 0 0 0 1 1h7"/></svg>',
}

export const DEFAULT_CHART_SETTINGS = {
  RESAMPLE_MAX_POINTS: 5000,
  LEGEND_FONT_SIZE: 9,
  HOVER_FONT_SIZE: 11,
  TICK_FONT_SIZE: 10,
  FONT_COLOR: 'white',
  FONT_FAMILY: 'Manrope, sans-serif',
  TITLE_FONT_SIZE: 10,
  AXIS_TITLE_FONT_SIZE: 11,
  MAX_NAME_LENGTH: 30,
  NUM_REGRESSION_POINTS: 200,
} as const

export const CHART_MARGINS = {
  DEFAULT_LEFT: 0,
  DEFAULT_RIGHT: 0,
  MULTIPLE_LEFT_AXES: 0,
  MULTIPLE_RIGHT_AXES: 0,
  SINGLE_AXIS_LEFT: 40,
  SINGLE_AXIS_RIGHT: 0,
  TOP: 0,
  BOTTOM: 40,
} as const

export const AXIS_DOMAIN_OFFSETS = {
  MULTIPLE_LEFT: 0.025,
  MULTIPLE_RIGHT: 0.975,
} as const

// Chart colors and theme
export const CHART_COLORS = {
  BACKGROUND: '#1a1a1a',
  TEXT: '#fff',
  GRID_LINE: '#555',
  LEGEND_BORDER: '#333',
  LEGEND_BACKGROUND: 'rgba(0, 0, 0, 0.5)',
} as const

// Common axis configuration defaults
export const AXIS_DEFAULTS = {
  gridcolor: 'transparent',
  ticklabeloverflow: 'hide past div',
  linewidth: 2,
  zeroline: false,
} as const

export const Y_AXIS_DEFAULTS = {
  ...AXIS_DEFAULTS,
  showline: false,
  tickmode: 'array', // Will be overridden when needed
} as const

export const X_AXIS_DEFAULTS = {
  ...AXIS_DEFAULTS,
  showline: true,
  spikesnap: 'cursor',
  linecolor: CHART_COLORS.GRID_LINE,
} as const

export const AXIS_TICK_FONT = {
  size: DEFAULT_CHART_SETTINGS.TICK_FONT_SIZE,
  family: DEFAULT_CHART_SETTINGS.FONT_FAMILY,
} as const

export const AXIS_TITLE_FONT = {
  size: DEFAULT_CHART_SETTINGS.AXIS_TITLE_FONT_SIZE,
  family: DEFAULT_CHART_SETTINGS.FONT_FAMILY,
} as const
